module.exports = __webpack_public_path__ + "static/media/mayuri.f908afc8.jpg";